module.exports = __webpack_public_path__ + "img/shop-similar-camera-boutique-24.8acb6cc.svg";